// src/components/PrivateRoute.js
import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import Sidebar from '../components/common/Navigation';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import '../index.css';

const PrivateRoute = () => {
  const { auth, loading, checkTokenValidity } = useAuth();

  useEffect(() => {
    checkTokenValidity(); // Verifica el token en cada carga de la página
  }, [auth, checkTokenValidity]); // Se ejecuta cuando el estado de `auth` cambia

  if (loading) {
    return <div>Loading...</div>; // Muestra un spinner o un mensaje de carga
  }

  //console.log('Auth state in PrivateRoute:', auth); // Log del estado de autenticación

  if (!auth) {
    return <Navigate to="/" />; // Redirige a login si no está autenticado
  }

  return (
    <div className="d-flex flex-column flex-md-row min-vh-100">
      <Sidebar />
      <div className="main-content flex-grow-1 bg-secondary-subtle d-flex flex-column overflow-auto">
        <Header />
        <div className="container-fluid flex-grow-1">
          <Outlet />
        </div>
        <Footer />
      </div>
    </div>
  );  
};

export default PrivateRoute;